import { RouteConfig } from 'react-router-config';
import { Redirect } from 'react-router-dom';
// import { Home } from '../../pages/home';
import { SelectStudioRouter } from '../../pages/studio/select-studio-router';
import { StudioEntryRouter } from '../../pages/studio';
import { PortalRouter } from '../../pages/studio/portal-router';
import { OrganizationRouter } from '../../pages/studio/organization-router';
import { SettingRouter } from '../../pages/studio/setting-router';
import { BillingRouter } from '../../pages/studio/billing-router';
import { ServiceOrderResult } from '../../pages/studio/service-order';
import { AuditHubRouter } from '../../pages/studio/audit-hub-router';

export const STUDIO_ROUTE: RouteConfig[] = [
  {
    path: '/studio',
    component: StudioEntryRouter,
    routes: [
      {
        path: '/studio/:studioId/portal',
        exact: true,
        component: PortalRouter,
      },
      {
        path: '/studio/select-studio',
        exact: true,
        component: SelectStudioRouter,
      },
      {
        path: '/studio/:studioId/organization',
        exact: true,
        component: OrganizationRouter,
      },
      {
        path: '/studio/:studioId/setting',
        exact: true,
        component: SettingRouter,
      },

      {
        path: '/studio/:studioId/fee',
        component: BillingRouter,
        routes: [
          {
            path: '/studio/:studioId/fee/order-result/:orderID',
            component: ServiceOrderResult,
          },
          /* {
            path: '/studio/:studioId/fee/overview',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/account-manage',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/order-manage',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/order-manage/detail/:orderID',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/billing-manage',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/overview/recharge',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/overview/withdrawal',
            exact: true,
            component: BillingRouter,
          },
          {
            path: '/studio/:studioId/fee/overview/transaction-details',
            exact: true,
            component: BillingRouter,
          },*/
        ],
      },
      {
        path: '/studio/:studioId/audithub',
        exact: true,
        component: AuditHubRouter,
      },

      {
        path: '*',
        exact: true,
        render: () => <Redirect to="/studio/select-studio" />,
      },
    ],
  },
];
